import opensansLatin from '@fontsource-variable/open-sans/files/open-sans-latin-wdth-normal.woff2'
import {If} from 'babel-plugin-jsx-control-statements'
// eslint-disable-next-line import/named
import {Script, ScriptStrategy} from 'gatsby'
import type {GatsbyBrowser} from 'gatsby'
import {Helmet} from 'react-helmet'
import {ThemeProvider} from 'uikit'
import ErrorModal from './src/components/ErrorModal'
import {initBrowserRum} from './src/gatsby/browserRum'
import {AlertProvider} from './src/hooks/useAlert'
import {CalculateProvider} from './src/hooks/useCalculate'
import {LoadingProvider} from './src/hooks/useLoading'
import '@fontsource-variable/open-sans/wdth.css'
import '@fontsource/ibm-plex-mono'
import {setupAbtests} from './src/utils/abtests'


export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({element}) => (
  <ThemeProvider>
    {element}
    <ErrorModal />
  </ThemeProvider>
)

// eslint-disable-next-line no-process-env
const gtm = process.env.GATSBY_GTM

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({element}) => {
  return (
    <LoadingProvider>
      <AlertProvider>
        <CalculateProvider>
          <Helmet>
            <link
                rel="preload"
                as="font"
                type="font/woff2"
                // eslint-disable-next-line no-process-env
                href={String(process.env.GATSBY_SITE_URL) + opensansLatin}
                crossOrigin="anonymous"
            />
            <script>
              {`
                (function () {
                  const url = new URL('${process.env.GATSBY_SITE_URL /* eslint-disable-line no-process-env */}');
                  if (url.hostname !== window.location.hostname) {
                    window.location.href = url.href;
                  }
                })();
              `.replace(/\s{2,}/g, '')}
            </script>
          </Helmet>
          <If condition={gtm}>
            <Script
                id="_gatsby-gtm-init"
                dangerouslySetInnerHTML={{
                  __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      })(window,'dataLayer');`,
                }}
            />
            <Script
                id="_gatbsy-gtm"
                strategy={ScriptStrategy.idle}
                src={`https://www.googletagmanager.com/gtm.js?id=${gtm}`}
            />
          </If>
          {element}
        </CalculateProvider>
      </AlertProvider>
    </LoadingProvider>
  )
}

if (typeof window !== 'undefined') {
  const abtests = setupAbtests()
  if (abtests) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({abtests})
  }
}

export const onClientEntry = () => {
  initBrowserRum()
}
